<template>
  <div>
    <DatePicker
      v-model="searchDate"
      type="daterange"
      placement="bottom-end"
      placeholder="选择时间"
      style="width: 200px"
      :options="options3"
    ></DatePicker>
    <Button type="primary" @click="resetFormData">清除</Button>
    <Button type="primary" @click="queryData">查询</Button>

    <Table :columns="columns" :data="tableData"></Table>

    <Modal
      v-model="detailVisible"
      :title="detailTitle"
      width="600"
    >
      <div class="detail-summary" v-if="detailList && detailList.length">
        激活人数(总人数)：{{ detailTotalUsers }}，
        付费人数：{{ detailPayUsers }}，
        付费总额：{{ detailPayAmount }}
      </div>
      <Table
        class="detail-modal-table"
        :columns="detailColumns"
        :data="detailList"
        border
      />
    </Modal>
  </div>
</template>

<script>
import { cmsAscribeInfo, cmsAscribeDetail } from "../../api/user";

export default {
  data() {
    return {
      searchDate: [],
      options3: {
        disabledDate(date) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return date && date.getTime() > today.getTime() - 1;
        },
      },
      tableData: [],
      // 明细弹窗
      detailVisible: false,
      detailTitle: "",
      detailList: [],
      detailColumns: [
        {
          title: "用户ID",
          key: "user_id",
        },
        {
          title: "充值金额",
          key: "rechange_num",
        },
      ],
      columns: [
        {
          title: "日期",
          key: "date",
        },
          {
          title: "快手_iOS",
          key: "ks_ios",
          width: 250,
          align: "center",
          render: (h, params) => {
            // 判断逻辑：如果 params.row.rows 中的 procurestatus 都等于 1
            const num = params.row.ks_ios.length;

            return h("div", [
           
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.showDetail(params.row.ks_ios, "快手_iOS");
                    },
                  },
                },
                num
              ),
            ]);
          },
        },
        {
          title: "快手_android",
          key: "ks_android",
          width: 250,
          align: "center",
          render: (h, params) => {
            // 判断逻辑：如果 params.row.rows 中的 procurestatus 都等于 1
            const num = params.row.ks_android.length;

            return h("div", [
           
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.showDetail(params.row.ks_android, "快手_android");
                    },
                  },
                },
                num
              ),
            ]);
          },
        },
        {title:"快手总人数",
              key: "ks",
        render: (h, params) => {
            return h("span", params.row.ks_ios.length + params.row.ks_android.length || '0');
          }
        },
         {
          title: "百度_iOS",
          key: "bd_ios",
          width: 250,
          align: "center",
          render: (h, params) => {
            // 判断逻辑：如果 params.row.rows 中的 procurestatus 都等于 1
            const num = params.row.bd_ios.length;

            return h("div", [
           
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.showDetail(params.row.bd_ios, "百度_iOS");
                    },
                  },
                },
                num
              ),
            ]);
          },
        },
        {
          title: "百度_android",
          key: "bd_android",
          width: 250,
          align: "center",
          render: (h, params) => {
            // 判断逻辑：如果 params.row.rows 中的 procurestatus 都等于 1
            const num = params.row.bd_android.length;

            return h("div", [
           
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => {
                        this.showDetail(params.row.bd_ios, "百度_android");

                    },
                  },
                },
                num
              ),
            ]);
          },
          
        },
        {title:"百度总人数",
              key: "bd",
        render: (h, params) => {
            return h("span", params.row.bd_ios.length + params.row.bd_android.length || '0');
          }
        },
         
      ],
    };
  },
  mounted() {
    // 默认选择最近一周
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - 7);
    this.searchDate = [start, end];
    this.queryData()
  },
  computed: {
    detailTotalUsers() {
      return this.detailList.length || 0;
    },
    detailPayUsers() {
      if (!this.detailList || !this.detailList.length) return 0;
      return this.detailList.filter(item => Number(item.rechange_num) > 0).length;
    },
    detailPayAmount() {
      if (!this.detailList || !this.detailList.length) return 0;
      const sum = this.detailList.reduce((total, item) => {
        const n = Number(item.rechange_num) || 0;
        return total + n;
      }, 0);
      return sum.toFixed(2);
    },
  },
  methods: {
    showDetail(list, channelLabel) {
      if (!list || !list.length) {
        this.detailList = [];
        this.detailTitle = channelLabel + " 明细（无数据）";
        this.detailVisible = true;
        return;
      }

      const params = {
        channel: channelLabel,
        users: list,
      };

      cmsAscribeDetail(params)
        .then((response) => {
          // 期望后端返回 [{ userId, rechargeAmount }, ...]
          this.detailList = response.data || [];
          this.detailTitle = channelLabel + " 明细";
          this.detailVisible = true;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    queryData() {
       var starttime = "";
      var endtime = "";
      if (this.searchDate.length > 0 && this.searchDate[0] != "") {
        starttime = this.formatDate(this.searchDate[0]);
        endtime = this.formatDate(this.searchDate[1]);
      }
      const params = {
        starttime,
        endtime,
        page: this.current,
      };
      this.fetchGoodsData(params);
    },
    // 格式化函数，将 Date 对象转换为 YYYY-MM-DD HH:mm:ss 格式
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
  fetchGoodsData(params = {}) {
      cmsAscribeInfo(params)
        .then((response) => {
          this.tableData = response.data; // 获取查询结果

        })
        .catch((error) => {
          console.error(error);
        });
    },
     
    resetFormData() {
      this.searchDate = [];
      this.tableData = [];
    },
  },
};
</script>

<style scoped>
.detail-modal-table {
  margin-top: 10px;
}
</style>
